
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/paypal/auth/success",
      function () {
        return require("private-next-pages/[locale]/paypal/auth/success/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/paypal/auth/success"])
      });
    }
  